module.exports = __webpack_public_path__ + "static/media/bree-blue.242fa6ca.png";